import PageTitle from "../components/PageTitle";
import { BsCheckLg } from "react-icons/bs";
import Button from "../components/Button";
import Collaboration from "../components/Collaboration";
import { useNavigate } from "react-router-dom";

export default function Completed(props) {
  const navigate = useNavigate();
  return (
    <>
      <PageTitle title="Shop Cart" path={["Pages ", "Shop Cart"]} />
      <div className=" max-w-5xl mx-auto my-24 flex justify-center ">
        <div className=" max-w-3xl border-b-2 border-l-2 border-[#D2D1D1] border-dashed flex flex-col items-center relative pb-16">
          <img
            alt=""
            className=" absolute -top-0 -left-12"
            src={require("../assets/completed/clock.png")}
          />
          <img
            alt=""
            className=" absolute -bottom-8 -right-4"
            src={require("../assets/completed/checklist.png")}
          />
          <div className=" rounded-full border-[#F6F7FA] border-4 p-5 mb-6">
            <BsCheckLg size={40} className="translate-y-1 text-pink" />
          </div>
          <h2 className="font-bold text-3xl mb-6 font-fontOne">
            Your Order Is Completed
          </h2>
          <p className="text-center text-[#8D92A7] mb-6 mx-16">
            Aliqua in minim sit reprehenderit est magna dolor fugiat sint
            adipisicing. Elit amet in labore velit deserunt quis sint et
            incididunt id exercitation. Occaecat non et dolore consectetur amet
            est excepteur veniam cillum laboris Lorem.
          </p>
          <Button color="pink" onClick={() => navigate("../shopgrid")}>
            Continue Shopping
          </Button>
        </div>
      </div>
      <Collaboration />
    </>
  );
}
